import React from "react";
import { Box } from "@mui/material";

function Notifications() {
  return (
    <Box
      sx={{
        py: 4,
      }}>
      {/* <List
        sx={{
          backgroundColor: "#fff",
        }}>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
        <ListItem>
          <ListItemText primary="You received" secondary="10 AM" />
        </ListItem>
      </List> */}
    </Box>
  );
}

export default Notifications;
